<template>
  <nav class="c-pagination c-pagination--bordered" v-if="visible">
    <a role="button" v-bind:class="{ 'is-disabled': actualPage === 1 }" @click="change(1)" class="c-pagination__item button">«</a>
    <a role="button" v-for="page in pages" :key="page" v-bind:class="{ 'is-active': actualPage == page }" @click="change(page)" class="c-pagination__item">{{ page }}</a>
    <a role="button" v-bind:class="{ 'is-disabled': actualPage === pagesAmount }" @click="change(pagesAmount)" class="c-pagination__item">»</a>
  </nav>
</template>

<script>
  export default {
    data: () => ({
      pages: [],
      pagesAmount: 1,
      actualPage: 1,
      visible: true
    }),
    async mounted () {
      this.calculeNumberOfPages()
    },
    methods: {
      change (page) {
        if (page === this.actualPage) {
          return
        }

        this.actualPage = page
        this.$emit('change', this.actualPage)
      },
      calculeNumberOfPages () {
        this.pagesAmount = Math.ceil(this.total / this.limit)

        let firstPage = 1
        let lastPage = this.pagesAmount

        if (this.pagesAmount > 7) {
          firstPage = this.actualPage - 3
          lastPage = this.actualPage + 3

          if (firstPage <= 0) {
            firstPage = 1
            const amount = 3 - (this.actualPage - firstPage)

            if (lastPage + amount <= this.pagesAmount) {
              lastPage += amount
            }
          }

          if (lastPage > this.pagesAmount) {
            lastPage = this.pagesAmount
            const amount = 3 - (lastPage - this.actualPage)
            if (firstPage - amount > 0) {
              firstPage -= amount
            }
          }
        }

        const pages = []
        for (let i = firstPage; i <= lastPage; i += 1) {
          pages.push(i)
        }

        this.pages = pages
      }
    },
    watch: {
      actualPage () {
        this.calculeNumberOfPages()
      },
      total () {
        this.calculeNumberOfPages()
      },
      pages (value) {
        this.visible = !!value.length
      },
      limit () {
        this.calculeNumberOfPages()
      }
    },
    props: {
      limit: {
        type: Number,
        required: true
      },
      total: {
        type: Number,
        required: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Paginator.vue?78e6ad6f